import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How would you describe your photography style?",
  answer: "Our aesthetic is defined by 'Refined Nostalgia'—a blend of soft, airy tones and timeless composition. We focus on natural lighting and authentic emotional resonance, ensuring your gallery feels like a sophisticated editorial collection rather than a series of posed snapshots."
}, {
  question: "When can we expect to receive our wedding gallery?",
  answer: "We believe in a meticulous curation process. You will receive a 'sneak peek' collection within 48 hours of your celebration. Your full, hand-edited digital gallery is typically delivered within 8 to 10 weeks, followed by the design of your custom linen-bound heirloom album."
}, {
  question: "Do you offer engagement sessions as part of your collections?",
  answer: "Absolutely. We highly recommend an engagement session as it allows us to build a rapport and helps you feel comfortable in front of the lens before the wedding day. It is a wonderful opportunity to capture your story in a more relaxed, lifestyle-focused setting."
}, {
  question: "How do we secure Ivory Lens for our wedding date?",
  answer: "To ensure the highest level of personalized service, we only accept a limited number of commissions each year. A signed digital contract and a retainer fee are required to reserve your date. We recommend reaching out 12 to 18 months in advance for peak wedding season."
}];
export default function RegulatoryFaq() {
  return <section data-section-id="224946" id="common-inquiries" className="relative bg-background py-24 border-y border-border overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_40%,transparent_100%)] opacity-10 pointer-events-none" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-12">
        <div className="mb-12 md:mb-16">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-8 bg-accent"></div>
            <span className="font-sans text-xs font-medium tracking-widest text-primary uppercase">
              The Details
            </span>
          </div>
          <h2 className="font-default text-4xl md:text-5xl font-light tracking-tight text-foreground">
            Common Inquiries
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`faq-${i}`} data-index={i} className="border-border rounded-md border-b first:border-t">
              <AccordionTrigger className="group [&>svg:last-child]:hidden hover:no-underline py-6 md:py-8 text-left transition-colors data-[state=open]:bg-secondary/30 px-4 -mx-4 md:px-6 md:-mx-6">
                <div className="flex w-full items-center justify-between gap-6">
                  <span className="font-default text-xl md:text-2xl font-normal text-foreground pr-4">
                    {faq.question}
                  </span>
                  <div className="flex size-10 shrink-0 items-center justify-center border border-border bg-background group-data-[state=open]:border-accent group-data-[state=open]:bg-accent/20 transition-colors duration-500 rounded-md">
                    <Plus className="size-4 text-primary transition-transform duration-500 group-data-[state=open]:rotate-45" />
                  </div>
                </div>
              </AccordionTrigger>
              <AccordionContent className="font-sans text-muted-foreground text-base font-light leading-relaxed pb-8 pt-2 px-4 -mx-4 md:px-6 md:-mx-6 md:pr-24">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}